<common-navigation></common-navigation>

<div class="default-box d-flex align-items-center mx-auto col-md-5 col-lg-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-xl-12 mb-100">
                <h3 class="display-4 box-title">New Password</h3> <br>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="error">
                   <button type="button" class="close" data-dismiss="alert">&times;</button>
                   {{errorMsg}}
                </div>
                <div class="alert alert-success alert-dismissible fade show" role="success" *ngIf="success">
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    Password successfully changed.
                </div>
                <div class="jumbotron p-3 mt-3 alert alert-warning alert-dismissible fade show password-notes">
                    <p>Password should contain 8 characters, 1 upper case letter and 1 decimal number</p>
                </div>
                <form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
                    <div class="md-input">
                        <input class="md-form-control"
                               required
                               type="password"
                               formControlName="password"
                               [ngClass]="{ 'error': (submitted && newPasswordForm.invalid && f.password.invalid) }"
                        >
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label>New Password</label>
                    </div>
                    <div class="md-input">
                      <input class="md-form-control"
                             required
                             type="password"
                             formControlName="confirmPassword"
                             [ngClass]="{ 'error': passwordNotMatch || (submitted && passwordNotMatch) || (submitted && newPasswordForm.invalid && f.confirmPassword.invalid) }"
                             (keyup)="checkPasswordMisMatch($event)"
                      >
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>Confirm New Password</label>
                    </div>
                    <button type="submit" class="btn btn-primary btn-block btn-submit"  [disabled]="loading">Set password
                      <img src="../../../../assets/images/loader.gif" *ngIf="loading"></button>
                </form>
            </div>
        </div>
    </div>
</div>
